// User:users
// Reservation:reservations
// Menu:menus
// Store:stores

import Vue from 'vue';
import firebase from 'firebase/compat/app';
import { userTypeCode } from '@/js/types'; // 절대 경로 사용

export default {};

export const database = {
	install(Vue) {
		Vue.prototype.$database = {
			currentTimestamp: function() {
				return firebase.firestore.Timestamp.now();
			},
			dateToTimestamp: function(date) {
				return firebase.firestore.Timestamp.fromDate(new Date(date));
			},
			timestampToDate: function(timestamp) {
				return timestamp.toDate();
			},

			//Users :: S
			onUsers: function(onSnapshot) {
				return firebase
					.firestore()
					.collection('users')
					.where('userType', '==', userTypeCode.customer.code)
					.onSnapshot(onSnapshot);
			},
			onDesigners: function(onSnapshot) {
				return firebase
					.firestore()
					.collection('users')
					.where('userType', '==', userTypeCode.designer.code)
					.onSnapshot(onSnapshot);
			},
			loadUsers: async function() {
				let itemList = [];
				await firebase
					.firestore()
					.collection('users')
					.where('userType', '==', userTypeCode.customer.code)
					.orderBy('lastLoginAt', 'desc')
					.orderBy('name', 'asc')
					.orderBy('nickname', 'asc')
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemInfo.uid = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadDesigners: async function() {
				let itemList = [];
				await firebase
					.firestore()
					.collection('users')
					.where('userType', '==', userTypeCode.designer.code)
					.orderBy('lastLoginAt', 'desc')
					.orderBy('storeName', 'asc')
					.orderBy('nickname', 'asc')
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemInfo.uid = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadUser: async function(id) {
				let item = null;
				await firebase
					.firestore()
					.collection('users')
					.doc(id)
					.get()
					.then(async documentSnapshot => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			loadPushTargetUsers: async function(targetUserType) {
				let itemList = [];
				await firebase
					.firestore()
					.collection('users')
					.where('userType', Array.isArray(targetUserType) ? 'in' : '==', targetUserType)
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemInfo.uid = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			addUser: async function(model) {
				let newDocRef = firebase
					.firestore()
					.collection('users')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editUser: async function(id, model) {
				await firebase
					.firestore()
					.collection('users')
					.doc(id)
					.update(model);
			},
			deleteUser: async function(id) {
				await firebase
					.firestore()
					.collection('users')
					.doc(id)
					.delete();
			},
			setUser: async function(id, model) {
				await firebase
					.firestore()
					.collection('users')
					.doc(id)
					.set(model);
			},
			//Users :: E

			//Appointments :: S
			onReservations: function(onSnapshot) {
				return (
					firebase
						.firestore()
						// .collection('reservations')
						.collection('appointments')
						.onSnapshot(onSnapshot)
				);
			},
			loadReservations: async function() {
				let itemList = [];
				await firebase
					.firestore()
					// .collection('reservations')
					.collection('appointments')
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadReservationsOfUser: async function(userUid) {
				let itemList = [];
				await firebase
					.firestore()
					// .collection('reservations')
					.collection('appointments')
					.where('userUid', '==', userUid)
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadReservationsOfDesigner: async function(designerUid, startDate, endDate) {
				let itemList = [];
				await firebase
					.firestore()
					// .collection('reservations')
					.collection('appointments')
					.where('designerUid', '==', designerUid)
					.where('reservationDay', '>=', startDate)
					.where('reservationDay', '<=', endDate)
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadReservation: async function(id) {
				let item = null;
				await firebase
					.firestore()
					// .collection('reservations')
					.collection('appointments')
					.doc(id)
					.get()
					.then(async documentSnapshot => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addReservation: async function(model) {
				let newDocRef = firebase
					.firestore()
					// .collection('reservations')
					.collection('appointments')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editReservation: async function(id, model) {
				await firebase
					.firestore()
					// .collection('reservations')
					.collection('appointments')
					.doc(id)
					.update(model);
			},
			deleteReservation: async function(id) {
				await firebase
					.firestore()
					// .collection('reservations')
					.collection('appointments')
					.doc(id)
					.delete();
			},
			setReservation: async function(id, model) {
				await firebase
					.firestore()
					// .collection('reservations')
					.collection('appointments')
					.doc(id)
					.set(model);
			},
			//Appointments :: E

			//User.Menus :: S
			loadMenus: async function(userUid) {
				let itemList = [];
				await firebase
					.firestore()
					.collection('users')
					.doc(userUid)
					.collection('menus')
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadMenu: async function(userUid, id) {
				let item = null;
				await firebase
					.firestore()
					.collection('users')
					.doc(userUid)
					.collection('menus')
					.doc(id)
					.get()
					.then(async documentSnapshot => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			//User.Menus :: E

			//Stores :: S
			onStores: function(onSnapshot) {
				return firebase
					.firestore()
					.collection('stores')
					.onSnapshot(onSnapshot);
			},
			loadStores: async function() {
				let itemList = [];
				await firebase
					.firestore()
					.collection('stores')
					.where('storeStatusType', '!=', 'StoreStatusType.delete')
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadStore: async function(id) {
				let item = null;
				await firebase
					.firestore()
					.collection('stores')
					.doc(id)
					.get()
					.then(async documentSnapshot => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addStore: async function(model) {
				let newDocRef = firebase
					.firestore()
					.collection('stores')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editStore: async function(id, model) {
				await firebase
					.firestore()
					.collection('stores')
					.doc(id)
					.update(model);
			},
			deleteStore: async function(id) {
				await firebase
					.firestore()
					.collection('stores')
					.doc(id)
					.delete();
			},
			setStore: async function(id, model) {
				await firebase
					.firestore()
					.collection('stores')
					.doc(id)
					.set(model);
			},
			//Stores :: E

			//Notifications :: S
			onNotifications: function(onSnapshot) {
				return firebase
					.firestore()
					.collection('notifications')
					.onSnapshot(onSnapshot);
			},
			loadNotifications: async function() {
				let itemList = [];
				await firebase
					.firestore()
					.collection('notifications')
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadNotification: async function(id) {
				let item = null;
				await firebase
					.firestore()
					.collection('notifications')
					.doc(id)
					.get()
					.then(async documentSnapshot => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addNotification: async function(model) {
				let newDocRef = firebase
					.firestore()
					.collection('notifications')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editNotification: async function(id, model) {
				await firebase
					.firestore()
					.collection('notifications')
					.doc(id)
					.update(model);
			},
			deleteNotification: async function(id) {
				await firebase
					.firestore()
					.collection('notifications')
					.doc(id)
					.delete();
			},
			setNotification: async function(id, model) {
				await firebase
					.firestore()
					.collection('notifications')
					.doc(id)
					.set(model);
			},
			//Notifications :: E

			//Users.NotificationCenters :: S
			addNotificationCenter: async function(userUid, model) {
				let newDocRef = firebase
					.firestore()
					.collection('users')
					.doc(userUid)
					.collection('notificationCenters')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			//Users.NotificationCenters :: E

			//Alerts :: S
			loadAlerts: async function() {
				let itemList = [];
				await firebase
					.firestore()
					.collection('alerts')
					.orderBy('sendAt', 'desc') // sendAt 필드를 기준으로 내림차순 정렬
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			addAlert: async function(model) {
				const newDocRef = firebase
					.firestore()
					.collection('alerts')
					.doc();
				model.id = newDocRef.id;
				await newDocRef.set(model);
			},
			setAlert: async function(id, model) {
				await firebase
					.firestore()
					.collection('alerts')
					.doc(id)
					.set(model);
			},
			//Alerts :: E

			//Banners :: S
			loadBanners: async function() {
				let itemList = [];
				await firebase
					.firestore()
					.collection('banners')
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			modifyBanner: async function(id, model) {
				await firebase
					.firestore()
					.collection('banners')
					.doc(id)
					.set(model);
			},
			addBanner: async function(model) {
				let newDocRef = firebase
					.firestore()
					.collection('banners')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			//Banners :: E

			//Pushes :: S
			addPush: async function(model) {
				let newDocRef = firebase
					.firestore()
					.collection('pushes')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			//Pushes :: E

			//treatments :: S
			onTreatments: function(onSnapshot) {
				return (
					firebase
						.firestore()
						.collection('treatments')
						// .where('level', '==', level)
						.onSnapshot(onSnapshot)
				);
			},
			loadTreatments: async function(level) {
				let itemList = [];
				await firebase
					.firestore()
					.collection('treatments')
					.where('level', '==', level)
					.orderBy('sort', 'asc')
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemInfo.uid = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadNextCode: async function(level) {
				let nextCode = null;
				let prefix = ''; // TL, TM, TS와 같은 prefix
				let baseCode = '001'; // 기본 값은 001로 시작

				// depth에 따라 prefix 설정
				switch (level) {
					case 1:
						prefix = 'TL';
						break;
					case 2:
						prefix = 'TM';
						break;
					case 3:
						prefix = 'TS';
						break;
					default:
						throw new Error('잘못된 depth 값입니다.');
				}

				// Firestore에서 가장 큰 코드를 가져와서 숫자 부분을 +1
				await firebase
					.firestore()
					.collection('treatments')
					.where('level', '==', level) // 동일한 depth 내에서
					.orderBy('code', 'desc') // code 필드를 기준으로 내림차순 정렬
					.limit(1) // 가장 큰 값을 가져옴
					.get()
					.then(querySnapshot => {
						if (!querySnapshot.empty) {
							let itemInfo = querySnapshot.docs[0].data();
							let lastCode = itemInfo.code;

							// 마지막 코드에서 숫자 부분을 추출하여 1 더함
							let numberPart = parseInt(lastCode.slice(2)); // TL001 -> 001 부분만 추출
							let nextNumber = (numberPart + 1).toString().padStart(3, '0'); // 1을 더하고 3자리로 맞춤
							nextCode = prefix + nextNumber; // 예: TL002
						} else {
							// 데이터가 없으면 기본값 설정
							nextCode = prefix + baseCode; // 예: TL001, TM001, TS001
						}
					});

				return nextCode;
			},
			addTreatment: async function(model) {
				let newDocRef = firebase
					.firestore()
					.collection('treatments')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			modifyTreatment: async function(model) {
				const id = model.id;

				await firebase
					.firestore()
					.collection('treatments')
					.doc(id)
					.set(model);
			},
			deleteTreatment: async function(id) {
				await firebase
					.firestore()
					.collection('treatments')
					.doc(id)
					.delete();
			},
			onTreatmentClassfications: function(onSnapshot, level) {
				return firebase
					.firestore()
					.collection('treatmentClassfications')
					.where('level', '==', level)
					.onSnapshot(onSnapshot);
			},
			loadTreatmentClassfications: async function(level) {
				let itemList = [];
				await firebase
					.firestore()
					.collection('treatmentClassfications')
					.where('level', '==', level)
					.orderBy('sort', 'asc')
					.get()
					.then(async querySnapshot => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemInfo.uid = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadUnderTreatmentClassfications: async function(code, level, codes) {
				let itemList = [];
				let query = firebase.firestore().collection('treatmentClassfications');

				// 공통 where 조건
				query = query.where('level', '==', level + 1).where(`levelCode${level}`, '==', code);

				// 레벨에 따라 추가적인 where 조건 적용
				if (level >= 1 && codes[0]) {
					query = query.where('levelCode1', '==', codes[0]);
				}
				if (level >= 2 && codes[1]) {
					query = query.where('levelCode2', '==', codes[1]);
				}
				if (level >= 3 && codes[2]) {
					query = query.where('levelCode3', '==', codes[2]);
				}

				// 정렬 조건
				query = query.orderBy('sort', 'asc');

				// Firestore에서 데이터 가져오기
				await query.get().then(async querySnapshot => {
					for (let i = 0; i < querySnapshot.docs.length; i++) {
						let itemInfo = querySnapshot.docs[i].data();
						itemInfo.id = querySnapshot.docs[i].id;
						itemInfo.uid = querySnapshot.docs[i].id;
						itemList.push(itemInfo);
					}
				});

				return itemList;
			},
			addTreatmentClassfication: async function(model) {
				let newDocRef = firebase
					.firestore()
					.collection('treatmentClassfications')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			modifyTreatmentClassfication: async function(model) {
				const id = model.id;

				await firebase
					.firestore()
					.collection('treatmentClassfications')
					.doc(id)
					.set(model);
			},
			deleteTreatmentClassfication: async function(code, level) {
				const querySnapshot = await firebase
					.firestore()
					.collection('treatmentClassfications')
					.where(`levelCode${level}`, '==', code)
					.get();

				// 쿼리 결과로 가져온 문서들 삭제
				const batch = firebase.firestore().batch(); // Batch를 사용하여 여러 문서 삭제
				querySnapshot.forEach(doc => {
					batch.delete(doc.ref);
				});

				// 배치 삭제 실행
				await batch.commit();
			},
			//treatments :: E

			//Configuration :: S
			loadConfiguration: async function(id) {
				let item = null;
				await firebase
					.firestore()
					.collection('configuration')
					.doc(id)
					.get()
					.then(async documentSnapshot => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			setConfiguration: async function(id, model) {
				await firebase
					.firestore()
					.collection('configuration')
					.doc(id)
					.set(model);
			},
			//Configuration :: E
		};
	},
};

Vue.use(database);
